import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import React, { memo, useMemo } from 'react'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { CRUISE_LINE_INFO, DEFAULT_CRUISE_LINE_FINE_PRINT_LINK } from 'constants/cruise'

interface Props {
  cruiseLine: App.CruiseLine
}

function CruiseFinePrint({ cruiseLine }: Props) {
  const { code: cruiseLineCode, name: cruiseLineName } = cruiseLine

  const termsAndConditionsLink = useMemo(() => {
    if (cruiseLineCode && cruiseLineCode in CRUISE_LINE_INFO) {
      return CRUISE_LINE_INFO[cruiseLineCode as keyof typeof CRUISE_LINE_INFO].finePrintLink
    }

    return DEFAULT_CRUISE_LINE_FINE_PRINT_LINK
  }, [cruiseLineCode])

  return (
    <Pane padding="32 32">
      <Group direction="vertical" gap={48}>
        <Heading
          align="center"
          variant="heading2"
        >
          Booking Terms & Conditions
        </Heading>
        <Pane>
          <LayoutContainer>
            <Group direction="vertical" gap={16}>
              <BodyText variant="medium">
                By completing your booking, you agree to the terms and conditions set forth by the
                cruise line operator. We acts solely as an intermediary and is not responsible for changes,
                cancellation policies, or specific rules established by the cruise company.
              </BodyText>
              <BodyText variant="medium">
                It is essential that you review and accept the official Terms and Conditions
                before finalizing your purchase. All policies regarding luggage, boarding, documentation, cancellations, and refunds
                are detailed in the operator’s official document.
              </BodyText>
              <TextLink size="medium" href={termsAndConditionsLink} target="_blank" weight="bold" underline>
                Click here to view the Terms and Conditions for {cruiseLineName}
              </TextLink>
            </Group>
          </LayoutContainer>
        </Pane>
      </Group>
    </Pane>
  )
}

export default memo(CruiseFinePrint)
